var map = {
	"./city/city.module": [
		"./src/app/main/admin/trial-tools/city/city.module.ts",
		"default~city-city-module~main-admin-trial-tools-trial_tool-module",
		"city-city-module"
	],
	"./countries/countries.module": [
		"./src/app/main/admin/trial-tools/countries/countries.module.ts",
		"default~countries-countries-module~main-admin-trial-tools-trial_tool-module",
		"countries-countries-module"
	],
	"./criteria/criteria.module": [
		"./src/app/main/admin/trial-tools/criteria/criteria.module.ts",
		"default~criteria-criteria-module~main-admin-trial-tools-trial_tool-module",
		"criteria-criteria-module"
	],
	"./disease/disease.module": [
		"./src/app/main/admin/trial-tools/disease/disease.module.ts",
		"default~disease-disease-module~main-admin-trial-tools-trial_tool-module",
		"disease-disease-module"
	],
	"./hospital/hospital.module": [
		"./src/app/main/admin/trial-tools/hospital/hospital.module.ts",
		"default~hospital-hospital-module~main-admin-trial-tools-trial_tool-module",
		"hospital-hospital-module"
	],
	"./investigator/investigator.module": [
		"./src/app/main/admin/trial-tools/investigator/investigator.module.ts",
		"default~investigator-investigator-module~main-admin-trial-tools-trial_tool-module~studies-studies-mo~3d60c003",
		"default~investigator-investigator-module~main-admin-trial-tools-trial_tool-module"
	],
	"./line-of-treatment/line_of_treatment.module": [
		"./src/app/main/admin/trial-tools/line-of-treatment/line_of_treatment.module.ts",
		"default~line-of-treatment-line_of_treatment-module~main-admin-trial-tools-trial_tool-module",
		"line-of-treatment-line_of_treatment-module"
	],
	"./main/admin/Dashboard/dashboard.module": [
		"./src/app/main/admin/Dashboard/dashboard.module.ts",
		"main-admin-Dashboard-dashboard-module"
	],
	"./main/admin/categories/categories.module": [
		"./src/app/main/admin/categories/categories.module.ts",
		"main-admin-categories-categories-module"
	],
	"./main/admin/cms/cms.module": [
		"./src/app/main/admin/cms/cms.module.ts",
		"main-admin-cms-cms-module"
	],
	"./main/admin/notification/notification.module": [
		"./src/app/main/admin/notification/notification.module.ts",
		"main-admin-notification-notification-module"
	],
	"./main/admin/patients/patients.module": [
		"./src/app/main/admin/patients/patients.module.ts",
		"main-admin-patients-patients-module"
	],
	"./main/admin/sponser/sponser-management.module": [
		"./src/app/main/admin/sponser/sponser-management.module.ts",
		"main-admin-sponser-sponser-management-module"
	],
	"./main/admin/sub-admin/sub-admin.module": [
		"./src/app/main/admin/sub-admin/sub-admin.module.ts",
		"main-admin-sub-admin-sub-admin-module"
	],
	"./main/admin/trial-tools/trial_tool.module": [
		"./src/app/main/admin/trial-tools/trial_tool.module.ts",
		"default~investigator-investigator-module~main-admin-trial-tools-trial_tool-module~studies-studies-mo~3d60c003",
		"default~criteria-criteria-module~main-admin-trial-tools-trial_tool-module",
		"default~countries-countries-module~main-admin-trial-tools-trial_tool-module",
		"default~main-admin-trial-tools-trial_tool-module~study-status-study-status-module",
		"default~city-city-module~main-admin-trial-tools-trial_tool-module",
		"default~disease-disease-module~main-admin-trial-tools-trial_tool-module",
		"default~main-admin-trial-tools-trial_tool-module~studies-studies-module",
		"default~hospital-hospital-module~main-admin-trial-tools-trial_tool-module",
		"default~line-of-treatment-line_of_treatment-module~main-admin-trial-tools-trial_tool-module",
		"default~investigator-investigator-module~main-admin-trial-tools-trial_tool-module",
		"main-admin-trial-tools-trial_tool-module"
	],
	"./main/investigator/patients/patients.module": [
		"./src/app/main/investigator/patients/patients.module.ts",
		"main-investigator-patients-patients-module"
	],
	"./studies/studies.module": [
		"./src/app/main/admin/trial-tools/studies/studies.module.ts",
		"default~investigator-investigator-module~main-admin-trial-tools-trial_tool-module~studies-studies-mo~3d60c003",
		"default~main-admin-trial-tools-trial_tool-module~studies-studies-module"
	],
	"./study-status/study-status.module": [
		"./src/app/main/admin/trial-tools/study-status/study-status.module.ts",
		"default~main-admin-trial-tools-trial_tool-module~study-status-study-status-module",
		"study-status-study-status-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;